import React from "react";
import { ImageOverlay } from "../elements/headerComponents";
import { Section, Card, Image } from "../elements/bodyComponents";
import { RecipePromo } from "../elements/recipes";
import { BodyCopy } from "../typography/typography";
import "../css/home.css";

import { ShowPage, HidePage } from "../helpers/helpers";

/*
    Homepage
*/
export class Homepage extends React.Component {
  componentDidMount() {
    document.querySelector(".globalNav").setAttribute("data-activepage", "");
    document.getElementById("pageContent").style.opacity = 1;

    ShowPage();
  }

  componentWillUnmount() {
    HidePage();
  }

  render() {
    return (
      <div id="home" className="layout-home usingMasterCard">
        <header className="pageHeader">
          <ImageOverlay classes="introOverlay text-align-center">
            <h3 className="sectionTitle font-louisana">
              Become the star of your kitchen with
            </h3>
            <h2 className="sectionTitleLarge font-louisana">
              Food Network Kitchen<sup>TM</sup> Inspirations.
            </h2>
            {/*<BodyCopy classes="color-gray margin-top-small">
                            Our globally inspired salad dressings, cooking sauces, and meal kits make trying new and exciting flavors more convenient than ever. Take cues from the latest food trends to create your own beautiful, share-worthy dishes.
                        </BodyCopy>
                         <Benefits classes="justify-center margin-top-medium" /> */}
          </ImageOverlay>
          <div className="header-background">
            <img
              className="cuttingBoard"
              src="img/headers/home_cuttingBoard.png"
              sizes="(max-width: 700px) 100vh, 65vw"
              srcSet="img/headers/home_cuttingBoard_retina.png 2x, img/headers/home_cuttingBoard.png 1x"
              alt=""
            />
            {window.isMobile === false && (
              <img
                className="lemons"
                src="img/headers/homeHeader_lemonGarlic.png"
                alt=""
              />
            )}
          </div>
          {window.isMobile === false &&
            window.isTablet === false && (
              <img
                className="productHero"
                src="img/home/productHero.png"
                srcSet="img/home/productHero_retina.png 2x, img/home/productHero.png 1x"
                alt="product group"
              />
            )}
          {window.isMobile === false &&
            window.isTablet === true && (
              <img
                className="productHero"
                src="img/home/productHero_retina_tablet.png"
                alt="product group"
              />
            )}
          {window.isMobile === true && (
            <img
              className="productHero"
              src="img/home/productHero_retina_mobile.png"
              alt="product group"
            />
          )}
        </header>

        <Section classes="productsIntro masterCard flex padding-y-xlarge padding-x-xlarge">
          <Card
            type="recipe"
            title="Dressings"
            color="yellow"
            classes="flex-equalSize text-align-center"
            link="/products/dressings"
            image="/img/home/dressingCard.jpg"
            button={{
              size: "primary",
              text: "See More"
            }}
            category="Dressings"
            pageType="Collection"
          >
            <BodyCopy classes="color-gray-medium margin-top-medium margin-bottom-large">
              Give your meal a makeover with dressings inspired by the Food Network Kitchen<sup>TM</sup>.
            </BodyCopy>
          </Card>
          <Card
            type="recipe"
            title="Sauces"
            color="purple"
            classes="flex-equalSize text-align-center"
            link="/products/sauces"
            image="/img/home/sauceCard.jpg"
            button={{
              size: "primary",
              text: "See More"
            }}
            category="Sauces"
            pageType="Collection"
          >
            <BodyCopy classes="color-gray-medium margin-top-medium margin-bottom-large">
              Add a twist on the familiar by adding Food Network Kitchen<sup>TM</sup>{" "}
              inspired sauces to your meal.
            </BodyCopy>
          </Card>
          <Card
            type="recipe"
            title="Meal Kits"
            color="green"
            classes="flex-equalSize text-align-center"
            link="/products/mealKits"
            image="/img/home/kitCard.jpg"
            button={{
              size: "primary",
              text: "See More"
            }}
            category="MealKits"
            pageType="Collection"
          >
            <BodyCopy classes="color-gray-medium margin-top-medium margin-bottom-large">
                Create flavorful, Food Network Kitchen<sup>TM</sup> inspired meals without all the hard work.
            </BodyCopy>
          </Card>
        </Section>

        <Section classes="recipesIntro flex padding-y-xlarge">
          <Image
            src="img/fullWidth/recipe_home_medium.jpg"
            sizes="(max-width: 1600px) 100vw, 1600px"
            srcSet="img/fullWidth/recipe_home_large.jpg 2702w, img/fullWidth/recipe_home_medium.jpg 1801w, img/fullWidth/recipe_home_small.jpg 1441w, img/fullWidth/recipe_home_xsmall.jpg 1081w, img/fullWidth/recipe_home_mbl.jpg 677w"
            classes="recipesIntro-image"
            alt="Recipe Intro"
          />
          <ImageOverlay classes="recipesIntro-overlay text-align-center color-white">
            <h1 className="headline uppercase">Recipes</h1>
            <h3 className="sectionTitle font-louisana margin-top-xsmall">
              Liven up weeknight dinners inspired by Food Network Kitchen<sup>TM</sup> with crave-worthy recipes.
            </h3>
            <BodyCopy classes="color-white font-helvetica focus">
              Our globally inspired salad dressings and cooking sauces add bold
              flavors and save you time.
            </BodyCopy>
          </ImageOverlay>
        </Section>

        <RecipePromo
          category="featured"
          color="yellow"
          max="4"
          classes="margin-bottom-large padding-x-xlarge"
          URL="/recipes"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/home.js